import React from 'react'

import BoxBody from './boxBody'

interface Props {
    boxStyle: React.CSSProperties
    height: number | null
    title: string | null
    text: string
    loading: boolean
}
class Loading extends React.Component<Props> {
    public static defaultProps = {
        boxStyle: {},
        height: null,
        title: null,
        text: 'Loading…',
        loading: true,
    }

    public render() {
        return (
            <div className="box box-default" style={this.props.boxStyle}>
                {!this.props.title ? null : (
                    <div className="box-header">
                        <h3 className="box-title">{this.props.title}</h3>
                    </div>
                )}

                <BoxBody {...this.props} className="loading" style={{ height: this.props.height ? this.props.height + 'px' : '100%' }} />
            </div>
        )
    }
}

export default Loading
